import React, { useState } from "react"
import ViewEditForm from "../components/ViewEditForm"
import Header from "../components/Header"
import { Paper } from "@mui/material"
import { spacing } from "./services/styleServices"

const styles = {
    pageContent: {
        margin: spacing(1),
        padding: spacing(1),
    },
}

const ViewEdit = (props) => {
    const [title, setTitle] = useState("View")

    return (
        <Header title={title}>
            <Paper sx={styles.pageContent} elevation={0}>
                <ViewEditForm {...props} setTitle={setTitle} />
            </Paper>
        </Header>
    )
}

export default ViewEdit
